/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ImageTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ImageTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {
    };
    const getData = () => {
        this.loadingIndicator.show = true;
        ImageTemplatesService.getImageTemplate($routeParams.id).then((imageTemplate: JS5Object) => {
            ImageTemplatesService.originalEditData = _.cloneDeep(imageTemplate);
            this.editData = imageTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewImageTemplate();
        }
        else {
            updateImageTemplate();
        }
    };

    const updateImageTemplate = () => {
        ImageTemplatesService.updateImageTemplate(this.editData).then((imageTemplate: JS5Object) => {
            ImageTemplatesService.originalEditData = _.cloneDeep(imageTemplate);
            this.editData = imageTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewImageTemplate = () => {
        ImageTemplatesService.createImageTemplate(this.editData).then((imageTemplate: JS5Object) => {
            $route.updateParams({id: imageTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && _.size(_.get(this.editData, 'params'))
                && _.size(_.get(this.editData, 'name')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(ImageTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'ImageTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = ImageTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Image Template',
                        location: '/system/templates/search',
                        params: {tab: 'ImageTemplates'}
                    });
                }
                getData();
            } else {
                ImageTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Image Template',
                    location: '/system/templates/search',
                    params: {tab: 'ImageTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        ImageTemplatesService.originalEditData = null;
        ImageTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            ImageTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = ImageTemplatesService;
        });
    };
}


angular.module('prism-ui.imageTemplate').component('imageTemplatesEditView', {
    templateUrl: 'system/templates/imageTemplate/editView/image-template-edit-view-template.html',
    controller: ImageTemplatesEditViewController,
    bindings: {
    }
});
